import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { followsApi } from '../api/follows.api.js';

const KEY = ['follows', 'list'];

export function useMyFollows() {
  return useQuery({
    queryKey: KEY,
    queryFn: () => followsApi.list(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useToggleFollowAuthor() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { author: string; followed: boolean }) =>
      vars.followed
        ? followsApi.unfollowAuthor(vars.author)
        : followsApi.followAuthor(vars.author),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['follows'] });
      qc.invalidateQueries({ queryKey: ['releases'] });
    },
  });
}

export function useToggleFollowGenre() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { genre: string; followed: boolean }) =>
      vars.followed
        ? followsApi.unfollowGenre(vars.genre)
        : followsApi.followGenre(vars.genre),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['follows'] });
      qc.invalidateQueries({ queryKey: ['releases'] });
    },
  });
}
